/* How radio advertising works (hub) — sticky chapter nav scroll-spy. */
(function () {
  function init() {
    var nav = document.querySelector("[data-gp-nav]");
    if (!nav) return;
    var links = nav.querySelectorAll(".gp-nav-link");
    if (!links.length) return;
    var ids = ["what", "pricing", "lead", "assets", "glossary", "tips"];

    function setActive(id) {
      links.forEach(function (a) {
        a.classList.toggle("is-on", a.getAttribute("href") === "#" + id);
      });
    }

    if ("IntersectionObserver" in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) setActive(e.target.id);
        });
      }, { rootMargin: "-30% 0px -60% 0px" });
      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) obs.observe(el);
      });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
